import React from 'react';
import { useMenu, Menu, MenuListItem } from '../../../menu';
import { IconButton } from '../../../icon-button';
import { Icon } from '../../../icon';
import { Spinner } from '../../../spinner';
import { StyledActionButtons, StyledDownloadMenuItem } from './styled';
import { head } from 'ramda';
import { ErrorActionButtons } from './error-action-buttons';
export const ActionButtons = ({ file, onAttach, onDownload, onRemoveFile, onPreview, onAbort, disabled }) => {
    var _a;
    const { isOpenMenu, handleOpenMenu, handleToggleMenu } = useMenu(false);
    const { uploadStatus } = file;
    const errorCode = (file === null || file === void 0 ? void 0 : file.errors) ? (_a = head(file === null || file === void 0 ? void 0 : file.errors)) === null || _a === void 0 ? void 0 : _a.code : undefined;
    const hasBlob = Boolean((file === null || file === void 0 ? void 0 : file.originalFile) || (file === null || file === void 0 ? void 0 : file.url));
    const preventedOpenMenu = (event) => {
        event.stopPropagation();
        handleOpenMenu();
    };
    const haveActions = Boolean(onPreview || onDownload || onRemoveFile || onAbort);
    return (React.createElement(StyledActionButtons, { onClick: (event) => {
            event.stopPropagation();
        } },
        haveActions && (uploadStatus === 'done' || uploadStatus === null) ? (React.createElement(Menu, { isOpen: isOpenMenu, onClickOutside: handleToggleMenu, content: React.createElement(React.Fragment, null,
                onPreview && hasBlob ? (React.createElement(MenuListItem, { role: "button", onClick: () => onPreview(file) }, "Preview")) : null,
                hasBlob && onDownload ? (React.createElement(StyledDownloadMenuItem, { role: "link", onClick: () => onDownload(file) }, "Download")) : null,
                onRemoveFile && (React.createElement(MenuListItem, { role: "button", disabled: disabled, onClick: () => onRemoveFile(file) }, "Delete"))) },
            React.createElement(IconButton, { onClick: preventedOpenMenu, "aria-label": "File actions" },
                React.createElement(Icon, { name: "kebab" })))) : null,
        uploadStatus === 'uploading' ? (React.createElement(React.Fragment, null,
            React.createElement(Spinner, { color: "success", colorShade: "highEmphasis" }),
            onAbort ? (React.createElement(IconButton, { onClick: () => onAbort(file), "data-testid": "file-uploader-abort-button" },
                React.createElement(Icon, { name: "close" }))) : null)) : null,
        uploadStatus === 'error' && (React.createElement(ErrorActionButtons, { file: file, onAttach: onAttach, onRemoveFile: onRemoveFile, errorCode: errorCode }))));
};
